import * as React from 'react';
import { Card } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';

export function RegularHeader() {
  const t = useTranslation();
  return (
    <Card.Header
      dataHook="installed-apps-title"
      title={t('manage-apps.regular-apps.card-header.title')}
    />
  );
}
